@let isDesktop = deviceService.isDesktop$ | async;

<div
  class="x-card x-card_size_m rounded-t-none block box-border"
  [ngClass]="{
    'bg-inherit': !isDesktop,
    'bg-(--tui-background-base-alt) desktop-width-limit mx-auto island-without-top-border':
      isDesktop,
  }"
>
  <div
    class="x-card x-card_size_m box-border w-full flex! flex-col min-h-0"
    [ngClass]="{
      'h-[calc(100vh-var(--x-desktop-header-height)-2rem)] desktop-width-limit mx-auto island-without-top-border bg-(--tui-background-base-alt)':
        isDesktop,
      'h-[calc(100vh-var(--x-mobile-header-height)-2rem)] bg-(--tui-background-base-alt)':
        !isDesktop,
    }"
  >
    <h1
      class="shrink-0"
      [ngClass]="{
        'text-[28px]/[24px] font-extrabold': isDesktop,
        'x-font-body-1-bold': !isDesktop,
      }"
    >
      {{ 'docflow_page.title' | translate }}
    </h1>
    <section class="mt-6 grow min-h-0">
      <iframe
        class="w-full h-full rounded-lg border-0"
        [src]="docflowIframeSrc"
        title="Payroll"
        scrolling="auto"
        loading="lazy"
        referrerpolicy="strict-origin-when-cross-origin"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
      ></iframe>
    </section>
  </div>
</div>
